var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7318 0.200439H3.6549C2.73684 0.200439 1.85638 0.487776 1.20722 0.999239C0.558056 1.5107 0.193359 2.20439 0.193359 2.92771V21.4732C0.193359 22.1965 0.558056 22.8902 1.20722 23.4016C1.85638 23.9131 2.73684 24.2004 3.6549 24.2004H14.7318C15.6499 24.2004 16.5303 23.9131 17.1795 23.4016C17.8287 22.8902 18.1934 22.1965 18.1934 21.4732V2.92771C18.1934 2.20439 17.8287 1.5107 17.1795 0.999239C16.5303 0.487776 15.6499 0.200439 14.7318 0.200439ZM9.19336 23.1095C8.04413 23.1095 7.11644 22.3786 7.11644 21.4732C7.11644 20.5677 8.04413 19.8368 9.19336 19.8368C10.3426 19.8368 11.2703 20.5677 11.2703 21.4732C11.2703 22.3786 10.3426 23.1095 9.19336 23.1095ZM15.4241 18.7459H2.96259V3.47317H15.4241V18.7459Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.2b05881980eda5b0b80b76f85f52a3af.svg";
export { ForwardRef as ReactComponent };